import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MergeConditionsPipe } from "process/tailoring-conditions/merge-conditions-pipe";
import ViewableTailoringCondition = stages.process.ViewableTailoringCondition;
@Component({
	selector: "stages-tailoring-conditions",
	templateUrl: "./tailoring-conditions.component.html",
	styleUrls: ["./tailoring-conditions.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterLink, TranslateModule, MergeConditionsPipe],
})
export class TailoringConditionsComponent {
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input() translateNone?: string;

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	tailoringConditions!: ViewableTailoringCondition[];
}
